const handleFetchEmployersFulfilled = (state, action) => {
  state.status = 'succeeded';
  const { context } = action.meta.arg;

  if (context !== 'search') {
    if (action.payload && action.payload.data && action.payload.data.data) {
      state.employers = action.payload.data.data;
      state.currentPage = action.payload.data.current_page;
      state.perPage = action.payload.data.per_page;
      state.totalPages = action.payload.data.last_page;
      state.totalEmployers = action.payload.data.total;
      state.lastUpdated = action.payload.last_update;

    } else {
      state.employers = action.payload || [];
      state.currentPage = 1;
      state.perPage = 10;
      state.totalPages = 0;
      state.totalEmployers = 0;
      state.lastUpdated = null;
      state.message = 'No job offers found';
    }
  }
};

const handleFetchDuplicateEmployersFulfilled = (state, action) => {
  state.status = 'succeeded';
  if (action.payload && action.payload.data && action.payload.data.data) {
    state.duplicateEmployers = action.payload.data.data;
    state.currentPage = action.payload.data.current_page;
    state.perPage = action.payload.data.per_page;
    state.totalPages = action.payload.data.last_page;
    state.totalEmployers = action.payload.data.total;
    state.lastUpdated = action.payload.data.last_update;
    state.employerIDs = action.payload.data.employer_ids || [];
    state.matched_columns = action.payload.data.matched_columns || [];
  } else {
    state.duplicateEmployers = action.payload || [];
    state.currentPage = 1;
    state.perPage = 10;
    state.totalPages = 0;
    state.totalEmployers = 0;
    state.lastUpdated = null;
    state.message = 'No job offers found';
    state.employerIDs = [];
    state.matched_columns = [];
  }
};

const handleEmpJobOffersFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.empJobOffers = action.payload.data;
};

const handleFetchEmployerFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentEmployer = action.payload.data;
  state.currentEmployer.id = action.payload.data.employer_id || 0;
  state.currentEmployer.user_id = action.payload.data.employer_user_id || 0;
};

const handleAddEmployerAddressFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  state.currentEmployer.address_count = state.currentEmployer.address_count + 1;

  // const hasResidentialAddress = state.addresses.some(address => address.type === 1);
  // const hasCorrespondenceAddress = state.addresses.some(address => address.type === 2);
  // const { type, id } = action?.payload?.data || {};
  // if (
  //   (!hasResidentialAddress && type === 1 && id) ||
  //   (!hasCorrespondenceAddress && type === 2 && id)
  // ) {
  //   const primaryAddressKey = type === 1 ? 'primary_residential_address' :
  //     type === 2 ? 'primary_correspondence_address' :
  //       null;

  //   if (primaryAddressKey) {
  //     debugger
  //     if (state.currentEmployer[primaryAddressKey] === null) {
  //       state.currentEmployer[primaryAddressKey] = action?.payload?.data;
  //     }
  //   }
  // }

};
const handleAddEmployerFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};
const handleUpdateEmployerAddressFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  const updatedEmpAddressIndex = state.addresses.findIndex(address => address.id === action.payload.data.id);
  if (updatedEmpAddressIndex === -1) {
    return;
  }
  const updatedAddress = state.addresses[updatedEmpAddressIndex];
  updatedAddress.address_line_1 = action.payload.data.address_line_1;
  updatedAddress.type = action.payload.data.type;

  if (updatedAddress.default === 1) {
    const primaryAddressKey = updatedAddress.type === 1 ? 'primary_residential_address' :
      updatedAddress.type === 2 ? 'primary_correspondence_address' :
        null;

    if (primaryAddressKey) {
      if (state.currentEmployer[primaryAddressKey] === null) {
        state.currentEmployer[primaryAddressKey] = {};
      }
      state.currentEmployer[primaryAddressKey].address_line_1 = updatedAddress.address_line_1;
    }
  }
};

const handleAddEmpCurrentWorkerFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentWorkers.push(action.payload.data);
  state.message = action.payload.message;
};

const handleDeleteEmpCurrentWorkerFulfilled = (state, action) => {
  state.status = 'succeeded';
  const employerWorkerId = action.payload?.data?.[0]?.id;
  state.currentWorkers = state.currentWorkers.filter(worker => worker.id !== employerWorkerId);
  state.message = action.payload.message;
};

const handleEmployerAddressListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.addresses = action.payload.data;
};

const handleDeleteEmpAddressFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  state.currentEmployer.address_count = Math.max(0, state.currentEmployer.address_count - 1);

  // Get the deleted address ID
  const deletedAddressId = action.payload.data[0]?.address_id;

  // Find the address before removing it to check its type
  const deletedAddress = state.addresses.find(address => address.id === deletedAddressId);

  // Remove the address from the addresses array
  state.addresses = state.addresses.filter(address => address.id !== deletedAddressId);

  // If the deleted address was a default address, remove it from currentEmployer
  if (deletedAddress) {
    if (deletedAddress.type === 1 && state.currentEmployer.primary_residential_address?.address_line_1 === deletedAddress.address_line_1) {
      state.currentEmployer.primary_residential_address = null;
    } else if (deletedAddress.type === 2 && state.currentEmployer.primary_correspondence_address?.address_line_1 === deletedAddress.address_line_1) {
      state.currentEmployer.primary_correspondence_address = null;
    }
  }

};

const handleUpdateEmpCurrentWorkerFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
  const updatedEmpWorkerIndex = state.currentWorkers.findIndex(currentWorker => currentWorker.id === action.payload.data.id);
  if (updatedEmpWorkerIndex !== -1) {
    state.currentWorkers[updatedEmpWorkerIndex] = action.payload.data;
  }
};

const handleDefaultEmpAddressFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;

  state.addresses.forEach(address => {
    address.default = address.id === action.payload.data.id ? action.payload.data.default : 0;
  });

  state.addresses.forEach(address => {
    address.default = address.id === action.payload.data.id ? action.payload.data.default : 0;
    if (address.default) {
      const primaryAddressKey = address.type === 1 ? 'primary_residential_address' :
        address.type === 2 ? 'primary_correspondence_address' :
          null;
      if (primaryAddressKey) {
        if (state.currentEmployer[primaryAddressKey] === null) {
          state.currentEmployer[primaryAddressKey] = {};
        }
        state.currentEmployer[primaryAddressKey].address_line_1 = address.address_line_1;
      }
    }
  });
};

const handleDFetchWorkerFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentWorkers = action.payload.data;
};

const handleDeleteWorkerFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleSetWorkerFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleGenderListFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.genderList = action.payload.data;
  state.message = action.payload.message;
};

const handleSpokenLanguageFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.spokenLanguages = action.payload.data;
  state.message = action.payload.message;
};

const handleEmployerDistrictFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.employerDistricts = action.payload.data;
  state.message = action.payload.message;
};

const handleSendOtpFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleSaveEmpInfoFulfilled = (state, action) => {
  state.status = 'succeeded';
  // const updatedData = action.payload.data[0];
  state.message = action.payload.message;
  // state.currentEmployer = {
  //   ...state.currentEmployer,
  //   expecting_baby_count: updatedData.expecting_baby_count,
  //   special_needs_count: updatedData.special_needs_count,
  //   adult_count: updatedData.adult_count,
  //   child_age_below_5_count: updatedData.child_age_below_5_count,
  //   child_age_5_8_count: updatedData.child_age_5_8_count,
  //   family_members: updatedData.family_member_info
  //     .filter(member => !member.deleted_at)
  //     .map(member => ({
  //       ...state.currentEmployer.family_members.find(fm => fm.id === member.id) || {},
  //       ...member
  //     }))
  // };
};
const handleUpdateEmpBasicFulfilled = (state, action) => {
  state.status = 'succeeded';
  const updatedData = action.payload.data;
  Object.keys(updatedData).forEach(key => {
    if (key !== 'spoken_language') {
      state.currentEmployer[key] = updatedData[key];
    }
  });
};

const handleUpdateEmployerBanOrRemoveStatusFulfilled = (state) => {
  state.status = 'succeeded';
}

const handleFetchEmployerActivityLogFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.employerActivityLogList = action.payload.data;
};

export {
  handleFetchEmployersFulfilled,
  handleEmpJobOffersFulfilled,
  handleFetchEmployerFulfilled,
  handleAddEmployerFulfilled,
  handleAddEmployerAddressFulfilled,
  handleUpdateEmployerAddressFulfilled,
  handleUpdateEmpCurrentWorkerFulfilled,
  handleAddEmpCurrentWorkerFulfilled,
  handleDeleteEmpCurrentWorkerFulfilled,
  handleEmployerAddressListFulfilled,
  handleDeleteEmpAddressFulfilled,
  handleDefaultEmpAddressFulfilled,
  handleDFetchWorkerFulfilled,
  handleDeleteWorkerFulfilled,
  handleSetWorkerFulfilled,
  handleGenderListFulfilled,
  handleSpokenLanguageFulfilled,
  handleEmployerDistrictFulfilled,
  handleSaveEmpInfoFulfilled,
  handleSendOtpFulfilled,
  handleUpdateEmpBasicFulfilled,
  handleFetchEmployerActivityLogFulfilled,
  handleFetchDuplicateEmployersFulfilled,
  handleUpdateEmployerBanOrRemoveStatusFulfilled
};